import axios from "axios";
import React, { useState, useEffect } from "react";
import { Config } from "../../../../../../Config";
import ErrorIcon from "../../../../../../Assets/Images/x-octagon.svg";

const VerificationModal = (props) => {
  const [ItemDetails, setItemDetails] = useState();
  const [Type, setType] = useState("");
  const [UserIsOwner, setUserIsOwner] = useState(false);
  const [OwnerType, setOwnerType] = useState("");

  useEffect(() => {
    if (props.RequestedItem.position) {
      setItemDetails(props.RequestedItem.position);
      setType("job");
    } else if (props.RequestedItem.project) {
      setItemDetails(props.RequestedItem.project);
      setType("project");
    } else {
      setItemDetails(props.RequestedItem.activity);
      setType("activity");
    }
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const submitApplication = () => {
    let URLparam;
    let ApplicationType;

    if (Type === "job") {
      if (props.MoreLikeThisIsActive) {
        URLparam =
          Config.PositionServiceURL +
          "/api/position/recommendation/similar/application";
      } else {
        URLparam = Config.PositionServiceURL + "/api/position/application";
      }
    } else if (Type === "project") {
      if (props.MoreLikeThisIsActive) {
        URLparam =
          Config.ProjectServiceURL +
          "/api/project/recommendation/similar/application";
      } else {
        URLparam = Config.ProjectServiceURL + "/api/project/application";
      }
    } else if (Type === "activity") {
      if (props.MoreLikeThisIsActive) {
        URLparam =
          Config.ActivityServiceURL +
          "/api/activity/recommendation/similar/application";
      } else {
        URLparam = Config.ActivityServiceURL + "/api/activity/application";
      }
    }

    let IsAnonymous = false;

    if (props.ApplicationType === "Normal") {
      ApplicationType = "DEFAULT";
    } else {
      ApplicationType = "ANONYMOUS";
      IsAnonymous = true;
    }

    let Data;
    if (props.MoreLikeThisIsActive) {
      Data = {
        id: props.RequestedItem.id,
        isAnonymous: IsAnonymous,
      };
    } else {
      Data = {
        recommendationId: props.RequestedItem.id,
        type: ApplicationType,
      };
    }

    let Req = {
      method: "POST",
      baseURL: window._env_.API_URL + URLparam,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        props.CloseModal();
        // ClickActivePage() function clicks the active page on ESS Homepage after
        // an application has been submitted
        // and the click refreshes the data of homepage.
        props.ClickActivePage();
      })
      .catch((Err) => {
        console.log(Err.response);
        if (Err.response.data.key === "not_allowed_error") {
          setUserIsOwner(true);
          if (
            Err.response.data.messages[0] ===
            "You cannot apply for a position that you are responsible Manager"
          ) {
            setOwnerType("Hiring manager");
          } else if (
            Err.response.data.messages[0] ===
            "You cannot apply for a position that you are responsible HR"
          ) {
            setOwnerType("HR");
          } else if (
            Err.response.data.messages[0] ===
            "You cannot apply for a position that you are responsible Manager"
          ) {
            setOwnerType("Manager");
          } else if (
            Err.response.data.messages[0] ===
            "You can not apply for your own activity"
          ) {
            setOwnerType("Owner");
          } else if (
            Err.response.data.messages[0] ===
            "You can not apply for your own project"
          ) {
            setOwnerType("Owner");
          }
        }
      });
  };
  const shortenTitle = (Title) => {
    if (window.innerWidth <= 450) {
      if (Title.length < 24) {
        return Title;
      } else {
        return Title.slice(0, 20) + " ...";
      }
    } else if (window.innerWidth > 450 && window.innerWidth < 1450) {
      if (Title.length < 30) {
        return Title;
      } else {
        return Title.slice(0, 26) + " ...";
      }
    } else if (window.innerWidth > 450 && window.innerWidth < 1960) {
      if (Title.length < 40) {
        return Title;
      } else {
        return Title.slice(0, 36) + " ...";
      }
    }
  };
  const handleDisplayPopup = () => {
    if (window.innerWidth <= 450) {
      if (ItemDetails.title.length < 24) {
        return null;
      } else {
        return <p className="popup-text">{ItemDetails.title}</p>;
      }
    } else if (window.innerWidth > 450 && window.innerWidth < 1450) {
      if (ItemDetails.title.length < 35) {
        return null;
      } else {
        return <p className="popup-text">{ItemDetails.title}</p>;
      }
    } else if (window.innerWidth > 450 && window.innerWidth < 1960) {
      if (ItemDetails.title.length < 45) {
        return null;
      } else {
        return <p className="popup-text">{ItemDetails.title}</p>;
      }
    }
  };
  return (
    <div className="verification-modal-overlay">
      <div className="outline" onClick={() => props.CloseModal()}></div>
      {ItemDetails === undefined ? null : (
        <div className="verification-modal">
          <section className="modal-head">
            <span>
              <h1>{shortenTitle(ItemDetails.title)}</h1>
              {handleDisplayPopup()}
              <p>{ItemDetails.workCity}</p>
            </span>
            <i onClick={() => props.CloseModal()} className="feather-x"></i>
          </section>
          {UserIsOwner ? (
            <section className="modal-body">
              <img className="error-icon" alt="Error" src={ErrorIcon} />
              <h1>
                You are not allowed to apply for this {Type} since you are the
                {" " + OwnerType} of this {Type}.
              </h1>
            </section>
          ) : (
            <React.Fragment>
              <section className="modal-body">
                {Type === "job" ? (
                  <h1>{translateText("confirm_apply_for_job")}</h1>
                ) : (
                  <React.Fragment>
                    {Type === "project" ? (
                      <h1>{translateText("confirm_apply_for_project")}</h1>
                    ) : (
                      <h1>{translateText("confirm_apply_for_activity")}</h1>
                    )}
                  </React.Fragment>
                )}
                {props.RequestedItem.application === null ? null : (
                  <React.Fragment>
                    {props.RequestedItem.application.cancelCounts > 0 ? (
                      <p>
                        {"(Already cancelled " +
                          props.RequestedItem.application.cancelCounts +
                          "time)"}
                      </p>
                    ) : null}
                  </React.Fragment>
                )}
              </section>
              <section className="modal-actions">
                <button onClick={() => props.CloseModal()}>
                  {translateText("cancel")}
                </button>
                {props.ApplicationType === "Normal" ? (
                  <button onClick={() => submitApplication()}>
                    {translateText("apply")}
                  </button>
                ) : (
                  <button onClick={() => submitApplication()}>
                    {translateText("anonymous_apply")}
                  </button>
                )}
              </section>
            </React.Fragment>
          )}
        </div>
      )}
    </div>
  );
};

export default VerificationModal;
